import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccessControlApiModule } from '@p2p/access-control/api';

import { AuthEffects } from './state/auth.effects';
import { AuthFacade } from './state/auth.facade';
import { featureKey, reducer } from './state/auth.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(featureKey, reducer),
        EffectsModule.forFeature([AuthEffects]),
        AccessControlApiModule
    ],
    providers: [AuthFacade]
})
export class AuthDomainModule {}
